/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
export type LocationScheduleLotGroupFragment = {
  __typename: 'LotGroup'
  locationSchedule: Array<{
    __typename: 'LocationSchedule'
    id: string
    dateAlias: string
    locations: Array<{
      __typename: 'Location'
      id: number
      startTime: any
      endTime: any
      workStatus: Types.LocationWorkStatus
      workStatusHuman: string
      allowOrders: boolean
      customerUrl: string
      lot: {
        __typename: 'Lot'
        id: number
        lotPath: string
        nameWithinGroup: string | null
      }
      locationItems: Array<{
        __typename: 'LocationItem'
        id: number
        status: Types.LocationItemStatus
        item: {
          __typename: 'Item'
          id: number
          name: string
          active: boolean
          description: string | null
          hasSpecialInstructions: boolean
          tags: Array<{
            __typename: 'ItemTag'
            id: string
            name: string
            imageSvgUrl: string | null
            highlighted: boolean
          }>
          upsellType: { __typename: 'UpsellType'; id: number; name: string }
          image: {
            __typename: 'ItemImage'
            small: string
            medium: string
            high: string
          }
          price: { __typename: 'Money'; cents: number; formatted: string }
        }
      }>
      menu: {
        __typename: 'Menu'
        id: number
        active: boolean
        foodTypes: Array<{
          __typename: 'FoodType'
          id: number
          name: string | null
        }>
      }
      truck: {
        __typename: 'Truck'
        id: number
        name: string
        image: { __typename: 'TruckImage'; medium: string }
      }
    }>
  }>
}

export const LocationScheduleLotGroupFragment = ({
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'locationScheduleLotGroupFragment' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'LotGroup' }
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'days' },
                value: { kind: 'IntValue', value: '5' }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dateAlias' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startTime' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'endTime' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workStatus' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'workStatusHuman' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'allowOrders' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerUrl' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lot' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lotPath' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nameWithinGroup' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'locationItems' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'sort' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                {
                                  kind: 'ObjectValue',
                                  fields: [
                                    {
                                      kind: 'ObjectField',
                                      name: { kind: 'Name', value: 'field' },
                                      value: {
                                        kind: 'EnumValue',
                                        value: 'auto'
                                      }
                                    },
                                    {
                                      kind: 'ObjectField',
                                      name: {
                                        kind: 'Name',
                                        value: 'direction'
                                      },
                                      value: { kind: 'EnumValue', value: 'asc' }
                                    }
                                  ]
                                }
                              ]
                            }
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'limit' },
                            value: { kind: 'IntValue', value: '6' }
                          }
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'item' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'active' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'description' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'tags' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'imageSvgUrl'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'highlighted'
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'upsellType' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'image' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'small' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'medium'
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'high' }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'cents' }
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'formatted'
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'hasSpecialInstructions'
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'menu' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'foodTypes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'truck' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'medium' }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown) as DocumentNode
